<template>
  <section class="section">
    <div class="container">
      <slot></slot>
      <h2 class="title">
        <a href="#" @click.prevent="$router.go(-1)" title="назад">
          <span class="icon" style="margin-right:0.5em;"><i class="fas fa-arrow-circle-left"></i></span>
        </a>
        Создание {{ $tc($route.params.model, 2) }}
      </h2>
      <Form
        :fdata="filteredFData"
        @submit="submit"
        :finputs="filteredFInputs"
        @update:finputs="filteredFInputs = $event"
        :errors="errors"
        :disabled="loading"
      >
        <div class="control">
          <input class="button is-success" type="submit" >
        </div>
      </Form>
    </div>

    <!-- модальное окно если успех -->
    <div :class="`modal ${$_.isEmpty(newData) ? '' : 'is-active'}`" >
      <div class="modal-background" @click="newData = {}"></div>
      <div class="modal-content">
        <div class="card">
          <div class="card-header">
            <p class="card-header-title">Запись создана</p>
            <a href="#" class="card-header-icon" aria-label="delete" @click="newData = {}">
              <span class="icon">
                <i class="fas fa-times-circle"></i>
              </span>
            </a>
          </div>
          <div class="card-content">
            {{newData}}
          </div>
          <div class="card-footer">
            <router-link :to="`/dashboard/${$route.params.app}/${$route.params.model}/${newData.pk || newData.id}`" class="card-footer-item">Посмотреть</router-link>
            <a href="#" class="card-footer-item" @click="newData = {}">Еще одна запись</a>
            <router-link :to="`/dashboard/${$route.params.app}/${$route.params.model}`" class="card-footer-item">Список записей</router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  components: {
    Form: () => import('@/components/Form.vue')
  },
  created () {
    this.getOptions(this.$route.path)
  },
  beforeRouteUpdate (to, from, next) {
    this.getOptions(to.path)
    next()
  },
  data () {
    return {
      fdata: [],
      finputs: {},
      loading: false,
      newData: {},
      errors: []
    }
  },
  computed: {
    filteredFData () {
      // делает вложенный объект document в один уровень с родительским объектом
      const obj = this.fdata
      for (const [key, field] of Object.entries(obj)) {
        if (['document'].includes(key)) {
          delete obj[key]
          for (const key1 in field.children || field) {
            obj[`${key}.${key1}`] = 'children' in field ? field.children[key1] : field[key1]
          }
        } else obj[key] = field
      }

      // отсекаем поля, доступные только для чтения
      for (const field in obj) {
        if (this.fdata[field].read_only) this.$delete(this.fdata, field)
      }

      // просто добавляем доп поле пароль (если есть поле пароль)
      if (Object.keys(obj).includes('password')) {
        obj.password1 = Object.assign(obj.password, { label: 'Повторите пароль' })
      }
      return obj
    },
    filteredFInputs: {
      set: function (finputs) {
        // собираем вложенные объекты
        finputs = this.$_.reduce(finputs, (acc, val, key) => {
          const splKey = key.split('.')
          if (splKey[1]) this.$_.set(acc, splKey, val); else acc[key] = val
          return acc
        }, {})
        this.finputs = finputs
      },
      get: function () {
        // расправляем вложенные объекты
        let finputs = this.finputs
        finputs = this.$_.reduce(finputs, (acc, val, key) => {
          if (['document'].includes(key)) {
            Object.assign(acc, this.$_.mapKeys(val, (val1, key1) => key + '.' + key1))
          } else acc[key] = val
          return acc
        }, {})
        return finputs
      }
    }
  },
  methods: {
    submit () {
      // создание объекта
      let data = this.finputs
      this.loading = true
      console.log('submitted', data)
      const url = `${this.$route.params.app}/${this.$route.params.model}/`

      // преобразуем поля, содержащие объекты в простые поля с pk или id, если имя поля не document
      // массивы объектов - в массив ключей
      // внутри поля документ так же преобразуем объекты в ключи объектов
      data = this.$_.mapValues(data, (val, key) => {
        // если поле - массив объектов, возвращаем массив ключей
        if (this.$_.isObject(val) && val.length) {
          return val.map(el => {
            return el.pk || el.id
          })
        }

        // если поле не документ - возвращаем id
        if (this.$_.isObject(val) && key !== 'document') return val.pk || val.id

        // внутри поля document
        if (key === 'document') {
          val = this.$_.mapValues(val, val1 => {
            if (this.$_.isObject(val1) && !val1.length) return val1.pk || val1.id
            if (this.$_.isObject(val1) && val1.length) {
              return val1.map(el => el.pk || el.id)
            }
            return val1
          })
        }
        return val
      })
      this.$axios.post(url, data, { headers: this.$store.state.user.axiosHeaders })
        .then(res => {
          console.log(res)
          this.newData = res.data
          this.loading = false
          // this.fdata = []
        })
        .catch(err => {
          this.loading = false
          if (err.response.status === 400) {
            console.log(err.response.data)
            this.errors = err.response.data
          }
        })
    },
    setDefaults () {
      // устанавливаем все ключи с пустыми значениями, а так же заначениями по умолчанию
      this.filteredFInputs = Object.fromEntries(Object.keys(this.filteredFData).filter(el => {
        return this.filteredFData[el].required
      }).map(el => {
        let val = null

        // значения по умолчанию
        switch (el) {
          case 'user':
          case 'owner':
          case 'document.user':
          case 'document.owner':
            val = this.$store.state.user.me
            break
          case 'organization':
          case 'document.organization':
            val = this.$store.state.user.appointment.organization
            break
        }
        // поле data
        if (this.$_.includes(el, 'start_date')) val = (new Date()).toISOString()
        // поле chioces
        if (this.filteredFData[el].type === 'choice') val = this.filteredFData[el].choices[0].value
        return [el, val]
      }))
    },
    getOptions (path) {
      // получаем типы полей модели
      this.loading = true
      const matched = path.split('/')
      const url = `${matched[2]}/${matched[3]}/`
      this.$axios.options(url, { headers: this.$store.state.user.axiosHeaders })
        .then(res => {
          this.fdata = res.data.actions.OPTIONS
          this.setDefaults()
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
